import React from 'react';
import { Helmet } from 'react-helmet-async';
import { siteInfo } from '../data/siteInfo';

const SEO = ({
  title,
  description = siteInfo.seo.defaultDescription,
  ogTitle,
  ogDescription,
  ogImage = siteInfo.seo.ogImage,
  ogUrl,
  canonical,
  schema
}) => {
  const companyName = siteInfo.companyName;
  const defaultTitle = `${companyName} | Property Investment in Preston`;
  const resolvedTitle = title ?? defaultTitle;
  const fullTitle =
    resolvedTitle.includes(companyName) || resolvedTitle.includes('|') ? resolvedTitle : `${resolvedTitle} | ${companyName}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <meta name="viewport" content="width=device-width, initial-scale=1" />

      <meta property="og:type" content="website" />
      <meta property="og:site_name" content={companyName} />
      <meta property="og:title" content={ogTitle || fullTitle} />
      <meta property="og:description" content={ogDescription || description} />
      <meta property="og:image" content={ogImage} />
      {ogUrl && <meta property="og:url" content={ogUrl} />}

      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle || fullTitle} />
      <meta name="twitter:description" content={ogDescription || description} />
      <meta name="twitter:image" content={ogImage} />

      {canonical && <link rel="canonical" href={canonical} />}

      {schema && (
        <script type="application/ld+json">
          {JSON.stringify(schema)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
